import  * as setupIcons from './icon';
import { setupDetails } from './details';
import { setupDialog } from './dialog';

const setupWebComponents = () => {
	setupDetails();
	setupDialog();
}

export { setupWebComponents };
